<mat-button-toggle-group #group="matButtonToggleGroup" [value]="selectedValue" [ngClass]="[(isMobile)?'button-alingment-mobile':'', isCustomHeight ?'custom-line-height':'']">
  <ng-container *ngFor="let button of buttonLabels">
    <mat-button-toggle [value]="button.intentCode" [disabled]="button.isDisabled" (change)="onValueChange($event, button, selectedValue)"
                       [ngClass]="[button.isDisabled ?'mat-disabled' :'']" [hidden]="button.hideCoverage">
      {{button.label}}
    </mat-button-toggle>
  </ng-container>
</mat-button-toggle-group>
